// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"39e98c46","719":"af4ecb92"}[chunkId] + ".chunk.css";
};